import {connect} from 'react-redux';
import {availabilityChangeRangeAndFetch,
  toggleShowRate
} from "../actions/AvailabilityActions";
import AvailabilityRangeComponent from '../components/AvailabilityRangeComponent';
import AvailabilityRangeMobileComponent from "../components/mobile/AvailabilityRangeMobileComponent";

const mapStateToProps = state => {
  return {
    showRate: state.availabilityReducer.showRate,
    criteria: state.availabilityReducer.criteria,
    displayNoOfNights: state.availabilityReducer.displayNoOfNights
  }

};

const mapDispatchToProps = dispatch => {
  return {
    onToggleShowRate: (showRate) => {
      dispatch(toggleShowRate(showRate))
    },
    onChangeRange: (criteria, days) => {
      dispatch(availabilityChangeRangeAndFetch(criteria, days))
    }
  }
};

const  AvailabilityRange = connect(mapStateToProps, mapDispatchToProps) (AvailabilityRangeComponent);
export const  AvailabilityRangeMobile = connect(mapStateToProps, mapDispatchToProps) (AvailabilityRangeMobileComponent);

export default AvailabilityRange


// WEBPACK FOOTER //
// ./src/containers/AvailabilityRange.js